import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../components/BaseComponent';
import { HBox, VBox } from '../../../components/Box';
import { Modal, ModalControls } from '../../../components/Modal';
import { Button } from '../../../components/Buttons';
import { Check, Edit } from '../../../components/Icon';
import { CompanySelection } from '../../Companies/components/CompanySelection';
import { CompanyUserSelection } from '../../Companies/components/CompanyUserSelectionComponent';
import { UserLabelById } from './UserLabelById';

import ButtonComponent from '../../../containers/App/Components/Button/Button';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import styles from './SearchCompanyAndUserComponent.module.css';

const STATE = {
  companySearch: '',
  company: null,
  userSearch: '',
  edit: false,
};

const Container = styled.div`
  .selected-company {
    background-color: #eee;
    padding: 6px;
    width: 100%;

    .icon {
      opacity: 0.4;
    }
  }

  .current-user {
    padding: 6px 12px;
    width: 100%;
    border-radius: 0.375rem;
    border: 1px solid #dee2e6;
    margin-right: 8px;
  }

  .user-selection {
    width: 100%;
    margin-top: 24px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class SearchCompanyAndUserComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  onUserInputChange(evt) {
    const { name, value } = evt.target;
    this.setState((prev, props) => {
      return { ...prev, user: { ...prev.user, [name]: value } };
    });
    return this;
  }

  render() {
    return (
      <Container>
        <HBox vCenter>
          {this.props.value ? (
            <div className="current-user">
              <UserLabelById user_id={this.props.value} />
            </div>
          ) : null}
          <ButtonComponent style={'ButtonSoftEdit'} size={'btn-sm'} onClick={this.setStateFn({ edit: true })}>
            <Edit />
          </ButtonComponent>
        </HBox>
        {this.renderModal()}
      </Container>
    );
  }

  renderModal() {
    if (!this.state.edit) return null;
    return (
      <>
        <ModalComponent
          className={styles.modal}
          onClose={this.reset.bind(this)}
          title={this.lbl('company.property.accountManagerId')}
        >
          <div>
            {!this.state.company && !this.props.homeCompanyId ? (
              this.renderCompanySearch()
            ) : (
              <div key="selected-company" className="selected-company">
                <Check />
                <span style={{ opacity: '0.4' }}>{this.state.company?.id}</span>&nbsp;
                {this.props.homeCompanyId ? 'Selecteer accountmanager' : this.state.company?.name}
              </div>
            )}

            <div className="user-selection">
              {this.state.company || this.props.homeCompanyId ? this.renderUserSearch(this.props.homeCompanyId) : null}
            </div>
          </div>

          <div className="d-flex gap-2 mt-2">
            <ButtonComponent
              style={'ButtonSoftEdit'}
              disabled={!this.state.user}
              onClick={e => {
                this.props.onSelect(this.state.user);
                this.reset();
              }}
            >
              {this.lbl('save')}
            </ButtonComponent>
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
              {this.lbl('cancel')}
            </ButtonComponent>
          </div>
        </ModalComponent>
      </>
    );
  }

  renderCompanySearch() {
    return <CompanySelection onSelect={company => this.setState({ company })} />;
  }

  renderUserSearch(homeCompanyId) {
    console.dir(this.state.company);
    return (
      <CompanyUserSelection
        companyId={homeCompanyId || this.state.company?.id}
        onSelect={user => this.setState({ user })}
        selectedUserId={this.state.user?.id}
      />
    );
  }
}

SearchCompanyAndUserComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  toggle: PropTypes.func,
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapDispatchToProps);

export const SearchCompanyAndUser = compose(withConnect, withRouter, injectIntl)(SearchCompanyAndUserComp);
